import User from "admin/types/interfaces/user";
import { useV1List } from "~/hooks/useV1List";
import { ACCESS_CONTROLLER_V1 } from "~/utils/accessController";

const useGroupUsers = ({
  groupName,
  activeOnly = true,
}: {
  groupName: string;
  activeOnly?: boolean;
}) => {
  return useV1List<User>(
    `${ACCESS_CONTROLLER_V1}/user-tags/${groupName}/users?active_only=${activeOnly}`
  );
};

export default useGroupUsers;
